// extracted by mini-css-extract-plugin
export default {"container":"orgStructureSettings_container__UQuYl","title":"orgStructureSettings_title__1h+yn","tableHeader":"orgStructureSettings_tableHeader__fpbOn"};